
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 23H1V.5a.5.5 0 00-1 0v23a.5.5 0 00.5.5h23a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M23.76 7.09a.5.5 0 00-.53.04c-2.12 1.6-3.86 1.1-5.7.55-1.71-.5-3.5-1.02-5.4.4a.64.64 0 00-.2.46v12a.5.5 0 001 0v-5.38c1.42-.92 2.76-.46 4.3.08 1.91.67 4.07 1.42 6.61-.5a.5.5 0 00.2-.4v-6.8a.5.5 0 00-.28-.45zm-.73 7c-2.02 1.41-3.7.83-5.47.2a8.95 8.95 0 00-2.9-.66 3.92 3.92 0 00-1.72.38V8.74c1.43-.95 2.77-.55 4.32-.1 1.7.5 3.59 1.06 5.78-.18zM3 15a.5.5 0 00.34-.14l6.13-5.74.53.13a.5.5 0 10.24-.97l-.79-.2A.5.5 0 009 8.2l-6.33 5.94A.5.5 0 003 15zm16.11-8.14a.5.5 0 00.4-.2L22.4 2.8a.5.5 0 00-.8-.6l-2.89 3.87a.5.5 0 00.4.8z"}})])
          )
        }
      }
    